import React from "react";

const AboutUs = () => {
  return (
    <section className="py-16 md:py-20 bg-[#F9FAFB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1 bg-[#C5A047]/10 text-[#C5A047] text-sm font-semibold rounded-full mb-3">
            WHO WE ARE
          </span>

          <h2 className="text-3xl md:text-4xl font-bold text-[#2C3E50] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            About Providence Federal Group
          </h2>

          <p className="text-gray-600 max-w-3xl mx-auto text-lg">
            A Service-Disabled Veteran-Owned Small Business delivering facility,
            operational, and technology support for federal and commercial clients.
          </p>
        </div>

        {/* Two Cards */}
        <div className="grid md:grid-cols-2 gap-8">

          {/* LEFT CARD */}
          <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 p-8 md:p-10">
            <span className="text-xl font-bold text-[#2C3E50] mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              COMPANY OVERVIEW
            </span>

            <p className="text-[#2C3E50] text-lg leading-relaxed mb-6 mt-2">
              Providence Federal Group is a Rhode Island–based government 
              contracting firm delivering facility management and professional services, 
              base operations support along with consulting and management services.
            </p>

            <div className="bg-[#F8FAFC] rounded-xl p-5 md:p-6 mb-6">
              <h4 className="text-sm font-semibold uppercase tracking-wide text-[#C5A047] mb-4">
                Core Capabilities
              </h4>

              <div className="grid sm:grid-cols-2 gap-3">
                <div className="flex items-start gap-3">
                  <span className="text-[#C5A047] mt-1">•</span>
                  <span className="text-gray-700 text-sm md:text-base">
                    Facilities management and maintenance
                  </span>
                </div>

                <div className="flex items-start gap-3">
                  <span className="text-[#C5A047] mt-1">•</span>
                  <span className="text-gray-700 text-sm md:text-base">
                    IT modernization and support
                  </span>
                </div>

                <div className="flex items-start gap-3">
                  <span className="text-[#C5A047] mt-1">•</span>
                  <span className="text-gray-700 text-sm md:text-base">
                    Logistics and supply chain operations
                  </span>
                </div>

                <div className="flex items-start gap-3">
                  <span className="text-[#C5A047] mt-1">•</span>
                  <span className="text-gray-700 text-sm md:text-base">
                    Disaster response and recovery
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT CARD */}
          <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 p-8 md:p-10">

            <span className="text-xl font-bold text-[#2C3E50] mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              MISSION-DRIVEN DELIVERY
            </span>

            <p className="text-[#2C3E50] text-lg leading-relaxed mb-6 mt-2">
              Providence Federal Group delivers mission-driven, value-focused solutions
              that enable government agencies to operate efficiently, securely, and reliably.
            </p>

            <p className="text-[#2C3E50] text-lg leading-relaxed mb-6 mt-2">
              We bring operational expertise, disciplined execution, and a strong commitment
              to compliance, ensuring results aligned with agency objectives and performance requirements.
            </p>

            <p className="text-[#2C3E50] text-lg leading-relaxed mb-6 mt-2">
              Our services and capabilities are designed to support critical government missions at every level.
            </p>

            <div className="mt-8">
              <a
                href="/capabilities"
                className="text-[#C5A047] font-semibold hover:underline"
              >
                View Capabilities →
              </a>
            </div>
          </div>

        </div>
        <div className="text-center mt-10 md:mt-12 max-w-3xl mx-auto">
          <p className="text-gray-700 text-base md:text-lg leading-relaxed">
            As an{" "}
            <span className="font-semibold text-[#2C3E50]">
              SDVOSB- and WOSB-certified firm
            </span>
            , Providence Federal Group combines operational discipline with a commitment
            to delivering measurable, repeatable results.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;